import { Grid,Typography, Button, ListItemButton, Card, List } from '@mui/material';
import React from 'react';
import {Swiper,SwiperSlide} from 'swiper/react';
import { Autoplay } from 'swiper';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { useRef } from 'react';
import { CardImageComponent } from '../../Component/Component';



const images = [
  {
    label: 'Fortnite Battle Royale',
    imgPath:
      'https://hips.hearstapps.com/digitalspyuk.cdnds.net/18/15/1523636434-capture52.PNG',
  },
  {
    label: 'League Of Legends (LOL)',
    imgPath:
      'https://miro.medium.com/max/604/1*wcjvmgRQkiGTTLme_VgreQ.jpeg',
  },
  {
    label: 'Minecraft',
    imgPath:
      'https://img.poki.com/cdn-cgi/image/quality=78,width=600,height=600,fit=cover,f=auto/12a0ed7c6bc09b73d6558c6f69ed7f5f.png',
  },
  {
    label: 'DOTA 2',
    imgPath:
      'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota2_social.jpg',
  },
  {
    label: 'Fortnite Battle Royale',
    imgPath:
      'https://hips.hearstapps.com/digitalspyuk.cdnds.net/18/15/1523636434-capture52.PNG',
  },
  {
    label: 'League Of Legends (LOL)',
    imgPath:
      'https://miro.medium.com/max/604/1*wcjvmgRQkiGTTLme_VgreQ.jpeg',
  },
  {
    label: 'Minecraft',
    imgPath:
      'https://img.poki.com/cdn-cgi/image/quality=78,width=600,height=600,fit=cover,f=auto/12a0ed7c6bc09b73d6558c6f69ed7f5f.png',
  },
  {
    label: 'DOTA 2',
    imgPath:
      'https://cdn.cloudflare.steamstatic.com/apps/dota2/images/dota2_social.jpg',
  },
];
const Trending7Days = () => {
 // Swiper instance
 const swiperRef = useRef(null);

 // Manipulate swiper from outside
 const goNext = () => {
   if (swiperRef.current && swiperRef.current.swiper) {
     swiperRef.current.swiper.slideNext();
   }
 };

 const goPrev = () => {
   if (swiperRef.current && swiperRef.current.swiper) {
     swiperRef.current.swiper.slidePrev();
   }
 };



 return (
       <Grid container sx={{padding:'3%'}}>
         <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{textAlign:'center'}}>
             <Typography variant='subtitle1' sx={{color: '#2f6df6'}}>TRENDING 7 DAYS</Typography><br />
             <Button sx={{background:'transparent',border:'none',color:'#2f6df6',fontSize:'12px'}}>View All</Button>
         </Grid>
        
         <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{textAlign:'left'}}>
             <Swiper
             ref={swiperRef}
              slidesPerView={4}
             spaceBetween={30}
             autoplay={{
               delay: 2500,
               disableOnInteraction: false
             }}
             modules={[Autoplay]}
             >
             {images.map((step) => (
             <SwiperSlide
             >
               <CardImageComponent key={step.label} sx={{height:'350px',width:'100%'}}>
               <img
               className='swiper-slide'
               src={step.imgPath}
               alt={step.label}
             />
             </CardImageComponent>
             <Typography variant='body'>{step.label}</Typography>
             <ListItemButton sx={{float:'right',color:'#2650b1'}} ><ArrowCircleRightOutlinedIcon /></ListItemButton>
             </SwiperSlide>
             
       ))}
             </Swiper>
         </Grid>
         <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display:'flex',justifyContent:'space-around',alignItems:'space-around',marginTop:'2%',padding:'1%'}}>
             <List>
             <ListItemButton sx={{color:'#2650b1'}} ><ArrowCircleLeftOutlinedIcon onClick={goPrev} />
             <ArrowCircleRightOutlinedIcon onClick={goNext}/></ListItemButton>
             </List>
         </Grid>
       </Grid>
 );
};

export default Trending7Days;